import React, { useEffect } from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
//import { useStoreActions, useStoreState } from '../../store/store.hooks'
//import { useForm } from 'react-hook-form'

const useStyles = makeStyles((theme) => ({
  noWebinars: {},

  root: {},

  sorry: {
    fontSize: '2rem',
  },
}))

const NoWebinars = ({}) => {
  const classes = useStyles()
  const { t } = useTranslation('webinars')

  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.sorry}>{t('sorryHeader')}</Typography>
        <Typography className={classes.noWebinars}>
          {t('noWebinars')}
        </Typography>
      </Grid>
    </>
  )
}

NoWebinars.displayName = 'NoWebinars'
export { NoWebinars }
export default NoWebinars
